import React from 'react';
import { Heading, ModalDialog, TextButton, Trigger } from '@zillow/constellation';
import TermsHtml from '../TermsCheckbox/TermsHtml';
import { TermType } from '@zg-rentals/ts-id-verification-client';

export default function NoticeToUsers() {
  const triggered = (
    <ModalDialog
      size={{ default: 'fullScreen', md: 'lg' }}
      renderHeader={
        <Heading level={4} as="h2">
          Notice to users
        </Heading>
      }
      renderBody={<TermsHtml termType={TermType.EXPERIAN_CIC_WRITTEN_CONSENT_RENTER} />}
    />
  );

  return (
    <Trigger triggered={triggered}>
      <TextButton>Notice to users</TextButton>
    </Trigger>
  );
}
